import PropTypes from 'prop-types';
import React, { Fragment } from 'react'
import { filter } from 'underscore'
import { connect } from 'react-redux';
import AnimateHeight from 'react-animate-height';
import { bindActionCreators } from 'redux';
import SVG from 'react-svg';

// Components
import {
	Intro,
	Interests,
	OtherInterests
} from './components'

let height;

if(typeof window !== 'undefined') {
	console.log(window.innerWidth)
	if(window.innerWidth < 767) {
		height = 0;
	}
}

class Filters extends React.Component {
    static propTypes = {
		user: PropTypes.object.isRequired,
		allInterests: PropTypes.array.isRequired,
		userInterests: PropTypes.array.isRequired,
		filteredSlug: PropTypes.string
	};

    state = {
    	height: typeof height !== 'undefined' ? height : 'auto'
	}

    shouldComponentUpdate(nextProps, nextState) {
		return !this.props.userInterests.length ||
			!this.props.allInterests.length ||
			this.props.userInterests.length !== nextProps.userInterests.length;
	}

    render() {

		let { user, allInterests, userInterests, filteredSlug } = this.props;

		if( !!user && !('ID' in user) && allInterests ) {
            userInterests = allInterests.filter(int => int.top_level).slice(0, 8)
		}

		const userInterestIDs = userInterests ? userInterests.map( (interest) => { return interest.ID; } ) : [],
			  otherInterests = allInterests ? filter( allInterests, (interest) => { return userInterestIDs.indexOf( interest.ID ) < 0 } ) : [];

		return (

			<div className="panel articles-interest-bar mtop20 mbot50 pleft15 pright15 ptop10 pbot10">

				{ !!userInterests.length ? (
					<Fragment>
                        <AnimateHeight
                            height={this.state.height}
                            duration={400}
							className={'filters__interests'}
                        >
                            <Intro slug={filteredSlug} />
                            <Interests interests={userInterests} slug={filteredSlug} />
                            { !!otherInterests.length && <OtherInterests interests={otherInterests} slug={filteredSlug} /> }
                        </AnimateHeight>

						<h5 className="filters__title">Filter interests</h5>

						<button
							className={'filters__hamburger'}
							onClick={() => this.setState({
								height: this.state.height === 0 ? 'auto' : 0
							})}
						>
							<SVG
								src={'/img/menu.svg'}
								style={{
									width: '24px'
								}}
							/>
						</button>
					</Fragment>
				) : (
					<p>No interests selected yet!</p>
				)}

				<div className="clearfix" />

			</div>
		)
		
	}
}

const mapStateToProps = state => ({
    allInterests: state.interests.all,
    userInterests: state.session.interests,
    user: state.session.user,
});

export default connect(
    mapStateToProps
)( Filters );




// WEBPACK FOOTER //
// ./src/js/views/Discover/components/Filters/index.jsx